goog.provide('el8.uiwidget.CollapsibleFeed');

goog.require('el8.model.base');
goog.require('el8.uiwidget.Feed');
goog.require('el8.uiwidget.CollapsibleFeedRenderer');


/**
 * A Feed where each item in the feed list can be
 * expanded/collapsed. Example usages are InboxFeed
 * (i.e., doc mgr) and report feeds.
 *
 * See Feed.js for an explanation of that general concept.
 */
el8.uiwidget.CollapsibleFeed = function(spec) {
    spec = spec || {};
    spec['rendererConstructor'] = spec.rendererConstructor || 
        el8.uiwidget.CollapsibleFeedRenderer;
    el8.uiwidget.Feed.prototype.constructor.call(this, spec);
};
el8.uiwidget.CollapsibleFeed.inheritsFrom(el8.uiwidget.Feed);

/**
 * Extend methods for collapsible feed
 */
el8.uiwidget.CollapsibleFeed.prototype.showItem = function(item) {
    el8.uiwidget.Feed.prototype.showItem.apply(this, arguments);
    this._feedRenderer.expandItem(item);
};

/**
 * Expose public methods from renderer
 */
el8.uiwidget.CollapsibleFeed.prototype.collapseItem = function(item) {
    return this._feedRenderer.collapseItem(item);
};
el8.uiwidget.CollapsibleFeed.prototype.expandItem = function(item) {
    return this._feedRenderer.expandItem(item);
};
el8.uiwidget.CollapsibleFeed.prototype.toggleItem = function(item) {
    return this._feedRenderer.toggleItem(item);
};


